import { defineMessages } from 'react-intl';

/** The copy of the credit block (design t5, t5b), the packs modal (g8) and the owner note (e4). */
export const creditMessages = defineMessages({
  // The credit block in the Studio rail (design release-kit t5) and its sticky bar (t5b).
  blockCostTitle: { id: 'app.sml.promote.credits.block.costTitle', defaultMessage: 'This costs' },
  blockHaveTitle: { id: 'app.sml.promote.credits.block.haveTitle', defaultMessage: 'You have' },
  blockCostUnit: {
    id: 'app.sml.promote.credits.block.costUnit',
    defaultMessage: '{count, plural, one {credit} other {credits}}',
  },
  blockFree: { id: 'app.sml.promote.credits.block.free', defaultMessage: 'Free' },
  blockFreeSub: { id: 'app.sml.promote.credits.block.freeSub', defaultMessage: 'Images use no credit' },
  blockProPlan: { id: 'app.sml.promote.credits.block.proPlan', defaultMessage: 'Pro plan' },
  blockProPlanSub: {
    id: 'app.sml.promote.credits.block.proPlanSub',
    defaultMessage: 'Full-song videos need Pro',
  },
  blockLeftUnit: { id: 'app.sml.promote.credits.block.leftUnit', defaultMessage: 'left' },
  blockAfterThis: { id: 'app.sml.promote.credits.block.afterThis', defaultMessage: 'After this: {count, number}' },
  blockNotTouched: { id: 'app.sml.promote.credits.block.notTouched', defaultMessage: 'Not touched' },
  blockResetsSub: { id: 'app.sml.promote.credits.block.resetsSub', defaultMessage: 'Plan resets {date}' },
  blockNoLimit: { id: 'app.sml.promote.credits.block.noLimit', defaultMessage: 'No limit' },
  blockUsedThisMonth: {
    id: 'app.sml.promote.credits.block.usedThisMonth',
    defaultMessage: '{count, number} used this month',
  },
  blockHow: { id: 'app.sml.promote.credits.block.how', defaultMessage: 'How? Plan and packs' },
  blockSplitPlan: { id: 'app.sml.promote.credits.block.splitPlan', defaultMessage: 'Plan' },
  blockSplitPlanLeft: {
    id: 'app.sml.promote.credits.block.splitPlanLeft',
    defaultMessage: '{left, number} of {limit, number} left',
  },
  blockSplitPacks: { id: 'app.sml.promote.credits.block.splitPacks', defaultMessage: 'Packs' },
  blockSplitPacksValue: {
    id: 'app.sml.promote.credits.block.splitPacksValue',
    defaultMessage: '{count, number} · never expire',
  },
  blockSplitPacksNone: { id: 'app.sml.promote.credits.block.splitPacksNone', defaultMessage: 'None' },
  blockSplitResets: { id: 'app.sml.promote.credits.block.splitResets', defaultMessage: 'Resets' },
  blockSplitResetsValue: {
    id: 'app.sml.promote.credits.block.splitResetsValue',
    defaultMessage: '{date} · plan credits only',
  },
  blockSplitSpends: { id: 'app.sml.promote.credits.block.splitSpends', defaultMessage: 'Spends' },
  blockSplitSpendsValue: {
    id: 'app.sml.promote.credits.block.splitSpendsValue',
    defaultMessage: 'Plan first, then packs',
  },
  blockBarCost: {
    id: 'app.sml.promote.credits.block.barCost',
    defaultMessage: '{count, plural, one {# credit} other {# credits}}',
  },
  blockBarHave: { id: 'app.sml.promote.credits.block.barHave', defaultMessage: 'You have {count, number}' },
  blockBarHow: { id: 'app.sml.promote.credits.block.barHow', defaultMessage: 'How?' },
  modalTitle: {
    id: 'app.sml.promote.credits.packs.title',
    defaultMessage: 'You used {used} of {limit} video credits this month.',
  },
  modalTitleNoLimit: {
    id: 'app.sml.promote.credits.packs.titleNoLimit',
    defaultMessage: 'You have no video credits left.',
  },
  modalBody: {
    id: 'app.sml.promote.credits.packs.body',
    defaultMessage: 'Your plan resets on {date}. Buy credits to make more now. Pack credits never expire.',
  },
  modalBodyNative: {
    id: 'app.sml.promote.credits.packs.bodyNative',
    defaultMessage: 'Your plan resets on {date}. Images still work.',
  },
  nativeNoPacks: {
    id: 'app.sml.promote.credits.packs.nativeNoPacks',
    defaultMessage: 'Video credits are not sold in the app.',
  },
  packName: { id: 'app.sml.promote.credits.packs.name', defaultMessage: '{count} video credits' },
  pack10: { id: 'app.sml.promote.credits.packs.pack10', defaultMessage: 'Ten clips or three full-song videos' },
  pack30: { id: 'app.sml.promote.credits.packs.pack30', defaultMessage: 'Ten full-song videos' },
  pack100: { id: 'app.sml.promote.credits.packs.pack100', defaultMessage: 'For managers and labels' },
  // The native apps still read these two ids (scripts/music24-native/i18n-keys.txt). Keep them
  // until they stop. The web shows no pack on Free.
  packFree: { id: 'app.sml.promote.credits.packs.free', defaultMessage: 'Short videos with the watermark' },
  upgradeLineFree: {
    id: 'app.sml.promote.credits.packs.upgradeLineFree',
    defaultMessage: 'Upgrade to Pro for full-song videos and no watermark.',
  },
  upgradeLine: {
    id: 'app.sml.promote.credits.packs.upgradeLine',
    defaultMessage: 'Or upgrade to {plan} for {count} video credits every month.',
  },
  upgrade: { id: 'app.sml.promote.credits.packs.upgrade', defaultMessage: 'Upgrade' },
  buy: { id: 'app.sml.promote.credits.packs.buy', defaultMessage: 'Buy {count} for {price}' },
  buyInBrowser: {
    id: 'app.sml.promote.credits.packs.buyInBrowser',
    defaultMessage: 'Open MUSIC24 in your browser to buy credits.',
  },
  // The check before a click that spends credits (owner rule 2026-10-06).
  gateBuyToMake: { id: 'app.sml.promote.credits.gate.buyToMake', defaultMessage: 'Buy credits to make it' },
  gateNotEnough: { id: 'app.sml.promote.credits.gate.notEnough', defaultMessage: 'Not enough video credits' },
  gateShortNote: {
    id: 'app.sml.promote.credits.gate.shortNote',
    defaultMessage: 'This needs {cost, plural, one {# credit} other {# credits}}. You have {left} left.',
  },
  gateBuyCredits: { id: 'app.sml.promote.credits.gate.buyCredits', defaultMessage: 'Buy credits' },
  ownerTitle: {
    id: 'app.sml.promote.credits.owner.title',
    defaultMessage: 'Ask the workspace owner for more video credits',
  },
  ownerBody: {
    id: 'app.sml.promote.credits.owner.body',
    defaultMessage:
      '{email} owns the plan of this workspace. They can buy a credit pack or upgrade. Images still work.',
  },
  ownerBodyNoEmail: {
    id: 'app.sml.promote.credits.owner.bodyNoEmail',
    defaultMessage: 'The owner of this workspace can buy a credit pack or upgrade. Images still work.',
  },
});
